import { NgModule } from '@angular/core';
import {
  BaseCustomerDepartmentStoreModule,
  BaseLocationWorkingTimeStoreModule,
  BaseRelatedCustomerLocationsStoreModule,
  BaseAssignmentsStoreModule,
  BaseOffersStoreModule,
} from 'base';
import { BaseCustomerAdministrationModule } from './modules/administration/administration.module';
import { BaseCustomerDashboardModule } from './modules/dashboard/dashboard.module';
import { BaseCustomerProviderModule } from './modules/provider/provider.module';
import { BaseCustomerSharedModule } from './shared/base-customer-shared.module';
import { BaseCustomerOnboardingModule } from './modules/onboarding/onboarding.module';
import { BaseCustomerInquiryModule } from './modules/inquiry/inquiry.module';

@NgModule({
  imports: [
    BaseCustomerAdministrationModule,
    BaseCustomerSharedModule,
    BaseCustomerInquiryModule,
    BaseCustomerProviderModule,
    BaseCustomerDashboardModule,
    BaseCustomerOnboardingModule,
    BaseCustomerDepartmentStoreModule,
    BaseLocationWorkingTimeStoreModule,
    BaseRelatedCustomerLocationsStoreModule,
    BaseAssignmentsStoreModule,
    BaseOffersStoreModule,
  ],
  exports: [
    BaseCustomerAdministrationModule,
    BaseCustomerSharedModule,
    BaseCustomerInquiryModule,
    BaseCustomerProviderModule,
    BaseCustomerDashboardModule,
    BaseCustomerOnboardingModule,
  ],
})
export class BaseCustomerModule {}
